import React from 'react';

import { ClaimPage } from '~/components/ClaimPage';
import { isCliveAppClaimPage } from '~/components/ClaimPage/claimPageVariant';
import CliveClaimPage from '~/components/ClaimPage/CliveApp/ClaimPage';
import { useCms } from '~/components/hooks/useCms';
import { SorClaimLockProvider } from '~/components/SystemOfRecord/SorClaimLockContext';

/**
 * ClaimPageRouter - Smart routing component for claim page variants
 *
 * This component determines which claim page variant to render based on
 * organization configuration. It uses lightweight hooks to minimize
 * performance overhead.
 *
 * Usage in CmsMainAuthenticatedInner.jsx:
 * ```
 * <PermissionProtectedRoute
 *   path="/claims/:claimId"
 *   render={(routerProps) => (
 *     <ClaimContainer claimId={Number(routerProps.match.params.claimId)}>
 *       <ClaimPageRouter />
 *     </ClaimContainer>
 *   )}
 * />
 * ```
 */
export const ClaimPageRouter: React.FC = () => {
  const { userOrganization } = useCms();

  const isCliveAppClaimPageEnabled = isCliveAppClaimPage(userOrganization);

  // Analytics/logging could be added here
  // e.g., trackVariantView('claim_page', variant);

  // Both variants take writes on the claim, so both are frozen while its System of Record has a change to confirm.
  return <SorClaimLockProvider>{isCliveAppClaimPageEnabled ? <CliveClaimPage /> : <ClaimPage />}</SorClaimLockProvider>;
};
